<template>
	<div class="rest-item" :class="{ 'unactive': !rest.isAvailable }" :key="rest.id" @click="$emit('checkRest', rest)">
		<div class="rest-item__content">
			<img :src="rest.picturePath" alt="" srcset="">
			<div class="rest-item__status" v-if="!rest.isAvailable">
				<Clock v-if="rest.isOrderTimeLimitExpired"/>
				<span>{{ statusText }}</span>
			</div>
		</div>
		<h3>{{ rest.name }}</h3>
		<div class="rest-item__bottom">
			<div class="rest-item__price">От {{ addThousandSeparator(rest.minimumOrderPrice) }} ₽</div>
			<div class="rest-item__time">Принимает заказы до {{ rest.deliveryTime }}</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { addThousandSeparator } from "@/helpers";

export default {
	props: ['rest'],

	components: {
		Clock: () => import('@/components/icons/Clock.vue'),
	},

	computed: {
		...mapGetters({
			currentDayStr: 'currentDayStr'
		}),
		statusText() {
			return this.rest.isOrderTimeLimitExpired == true ?
				'Приём заказов завершён' :
				'Меню не опубликовано'
		},
		currentDay() {
			return this.currentDayStr == 'today' ? 'сегодня' : 'завтра'
		}
	},
	methods: {
		addThousandSeparator,
	}
}
</script>

<style lang='scss'>
.rest-item {
	cursor: pointer;

	h3 {
		margin-top: 8px;
		font-size: 18px;
		font-family: $mainFontBoldNew;
		line-height: 24px;
	}

	&__content {
		width: 100%;
		height: 160px;
		position: relative;
		border-radius: 16px;
		overflow: hidden;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	&__status {
		height: 24px;
		padding: 4px 8px;
		display: flex;
		gap: 4px;
		align-items: center;
		position: absolute;
		left: 12px;
		bottom: 12px;
		background-color: #FFF;
		border-radius: 16px;
		font-size: 12px;
		font-weight: 500;

		svg {
			width: 16px;
			height: 16px;
		}
	}

	&__bottom {
		width: 100%;
		display: flex;
		align-items: center;
		font-size: clamp(0.5rem, -0.25rem + 1.1111vw, 0.75rem);
		font-family: $mainFontMediumNew;
		line-height: 16px;
	}

	&__price {
		min-width: 70px;

		&::after {
			position: relative;
			content: '•';
			margin-left: 8px;
		}
	}

	&__time { margin-left: 8px }

	&.unactive {
		cursor: default;

		img { opacity: .5 }
	}

	@media (max-width: 1280px) {
		h3 { font-size: 16px }
	}

	@media (max-width: 1080px) {
		h3 { font-size: 20px }

		&-bottom { font-size: clamp(0.625rem, 0.1635rem + 0.9615vw, 0.8125rem) }
	}

	@media (max-width: 580px) {
		&-bottom { font-size: 12px }

		&__content {
			min-height: 160px;
			height: 42vw
		}

		h3 { font-size: 18px }
	}
}
</style>